const styles = {
  container: {
    height: 200,
    overflow: 'hidden',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    position: 'absolute',
    borderRadius: 2,
    lineHeight: 1.3,
    border: '1px solid #aaa',
    boxShadow: '0 1px 6px rgba(0,0,0,.25)',
    outline: 0,
    cursor: 'pointer',
    display: 'flex',
    width: '100%'
  },
  option: {
    padding: 7,
    cursor: 'pointer',
    fontFamily: 'verdana',
    color: '#000',
    height: 14,
    fontSize: 10,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  selected: {
    background: 'rgb(51, 122, 183)',
    color: '#fff'
  }
}

export default styles
